import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=76bcd693&scoped=true&"
import script from "./OrderBook.vue?vue&type=script&lang=js&"
export * from "./OrderBook.vue?vue&type=script&lang=js&"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=76bcd693&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bcd693",
  null
  
)

export default component.exports